import { classNames } from 'libs/react';
import { MediaViewer } from 'components/media/MediaViewer';
import { React } from 'libs/react';
import './MediaGalleryItem.scss';
/**
 * @component MediaGalleryItem
 * @since 1.0.0
 */
export function MediaGalleryItem(props) {
    const { style, media, frame, selected, disabled } = Object.assign({ style: 'normal' }, props);
    const { x, y, w, h } = frame;
    /**
     * @function onClick
     * @since 1.0.0
     * @hidden
     */
    function onClick() {
        if (disabled) {
            return;
        }
        if (props.onPress) {
            props.onPress(media);
        }
    }
    /**
     * @function onMouseEnter
     * @since 1.0.0
     * @hidden
     */
    function onMouseEnter() {
        if (disabled) {
            return;
        }
        if (props.onMouseEnter) {
            props.onMouseEnter(media);
        }
    }
    /**
     * @function onMouseLeave
     * @since 1.0.0
     * @hidden
     */
    function onMouseLeave() {
        if (disabled) {
            return;
        }
        if (props.onMouseLeave) {
            props.onMouseLeave(media);
        }
    }
    const transform = `
		translateX(${x}px)
		translateY(${y}px)
	`;
    const styles = {
        width: w,
        height: h,
        transform
    };
    const className = classNames('media-gallery-item', 'media-gallery-item--' + style, { 'media-gallery-item--is-selected': selected }, { 'media-gallery-item--is-disabled': disabled }, props.className);
    return (React.createElement("div", { style: styles, className: className, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onClick: onClick },
        React.createElement(MediaViewer, { media: media })));
}
